"use client";

import { axiosAdmin } from "@/lib/axios";
import { useGenericMutation } from "@/components/query/useGenericMutation";

export const useAddToWishlist = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.post("/user/wishlist", data),
    onSuccessMessage: "Item Added to wishlist",
    queryKeyToInvalidate: ["getallwishlist"],
  });
};

export const useRemoveFromWishlist = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.delete("/user/wishlist/clear", data),
    onSuccessMessage: "Item Removed from wishlist",
    queryKeyToInvalidate: ["getallwishlist"],
  });
};

export const useRemoveSingleFromWishlist = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.patch("/user/wishlist/remove", data),
    onSuccessMessage: "Item Removed from wishlist",
    queryKeyToInvalidate: ["getallwishlist"],
  });
};